import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCustomisation } from '../customisation/customisationSlice';
import {
  fetchPointsLeaderboardByClient,
  fetchPointsLeaderboardByProgram,
  selectLeaderboard,
} from './leaderboardSlice';
const useStyles = makeStyles((theme) => ({
  leaderboardContainer: {
    display: 'flex',
    flexFlow: 'row wrap',
    flexGrow: 1,
    paddingTop: 60,
    paddingBottom: 60,
    justifyContent: 'space-around',
    backgroundColor: '#ddd',
    fontSize: 16,
  },
  leaderCard: {
    minWidth: 350,
    maxWidth: 450,
    marginBottom: 32,
    flexGrow: 1,
    marginLeft: 40,
    marginRight: 40,
  },
  cardTitle: {
    padding: 24,
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    fontSize: 24,
    textAlign: 'center',
    fontWeight: 'bold',
  },

  memberContainer: {
    display: 'flex',
    flexFlow: 'row nowrap',
    padding: 24,
    borderBottom: '1px solid #ddd',
    alignItems: 'center',
    // justifyContent: 'center',
  },
  position: {
    width: 40,
    borderRadius: '50%',
    backgroundColor: '#ddd',
    height: 40,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  memberDetailsContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    marginLeft: 32,
  },
  memberName: {
    fontWeight: 'bold',
  },
  memberPoints: {
    color: '#a29c9c',
    fontWeight: 'bold',
  },
}));

export default function Leaderboard(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [value, setValue] = useState('');
  const {clientLeaderboard, loading, error, programLeaderboard} =
    useSelector(selectLeaderboard);
    const {customisation} =
    useSelector(selectCustomisation);
  let jwtToken = localStorage.getItem('clientToken');
  useEffect(() => {
    dispatch(
      fetchPointsLeaderboardByClient({
        token: jwtToken,
        clientID: Number(process.env.REACT_APP_CLIENT_ID),
      })
    );
    dispatch(
      fetchPointsLeaderboardByProgram({
        token: jwtToken,
        programID: 1,
      })
    );
  }, [dispatch]);

  const formatPTS = (str) => {
    return str.toLocaleString() 
  }

  return (
    <div className={classes.leaderboardContainer}>
      <Card className={classes.leaderCard}>
        <div className={classes.cardTitle}>Current Promotion</div>
        {programLeaderboard.map((member, index) => (
          <div key={member.userID} className={classes.memberContainer}>
            <div className={classes.position}>{index + 1} </div>
            <div className={classes.memberDetailsContainer}>
              <div className={classes.memberName}>{member.username} </div>
              <div className={classes.memberPoints}>
                {formatPTS(member.totalPointsEarned)} pts
              </div>
            </div>
          </div>
        ))}
      </Card>
      <Card className={classes.leaderCard}>
        <div className={classes.cardTitle}>All Time</div>
        {clientLeaderboard.map((member, index) => (
          <div key={member.userID} className={classes.memberContainer}>
            <div className={classes.position}>{index + 1} </div>
            <div className={classes.memberDetailsContainer}>
              <div className={classes.memberName}>{member.username} </div>
              <div className={classes.memberPoints}>
                {formatPTS(member.totalPointsEarned)} pts
              </div>
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
}
